import { faAws } from '@fortawesome/free-brands-svg-icons/faAws';
import { faCloudflare } from '@fortawesome/free-brands-svg-icons/faCloudflare';
import { faDiscord } from '@fortawesome/free-brands-svg-icons/faDiscord';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons/faAngleDoubleLeft';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons/faBullhorn';
import { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar';
import { faChartBar } from '@fortawesome/free-solid-svg-icons/faChartBar';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faCircleHalfStroke } from '@fortawesome/free-solid-svg-icons/faCircleHalfStroke';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faCloud } from '@fortawesome/free-solid-svg-icons/faCloud';
import { faCloudUpload } from '@fortawesome/free-solid-svg-icons/faCloudUpload';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons/faCloudUploadAlt';
import { faCode } from '@fortawesome/free-solid-svg-icons/faCode';
import { faCodeBranch } from '@fortawesome/free-solid-svg-icons/faCodeBranch';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faCogs } from '@fortawesome/free-solid-svg-icons/faCogs';
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments';
import { faCompressAlt } from '@fortawesome/free-solid-svg-icons/faCompressAlt';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons/faEllipsisV';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons/faFileAlt';
import { faFileExport } from '@fortawesome/free-solid-svg-icons/faFileExport';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons/faFileSignature';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faFolder } from '@fortawesome/free-solid-svg-icons/faFolder';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen';
import { faFolderTree } from '@fortawesome/free-solid-svg-icons/faFolderTree';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { faHashtag } from '@fortawesome/free-solid-svg-icons/faHashtag';
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faICursor } from '@fortawesome/free-solid-svg-icons/faICursor';
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage';
import { faImages } from '@fortawesome/free-solid-svg-icons/faImages';
import { faInbox } from '@fortawesome/free-solid-svg-icons/faInbox';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons/faMinusSquare';
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon';
import { faMusic } from '@fortawesome/free-solid-svg-icons/faMusic';
import { faPager } from '@fortawesome/free-solid-svg-icons/faPager';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import { faPaste } from '@fortawesome/free-solid-svg-icons/faPaste';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faQuoteRight } from '@fortawesome/free-solid-svg-icons/faQuoteRight';
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';
import { faRobot } from '@fortawesome/free-solid-svg-icons/faRobot';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faServer } from '@fortawesome/free-solid-svg-icons/faServer';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import { faShield } from '@fortawesome/free-solid-svg-icons/faShield';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons/faShieldAlt';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faSortAlphaUp } from '@fortawesome/free-solid-svg-icons/faSortAlphaUp';
import { faSortAmountDown } from '@fortawesome/free-solid-svg-icons/faSortAmountDown';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faSquare } from '@fortawesome/free-solid-svg-icons/faSquare';
import { faSun } from '@fortawesome/free-solid-svg-icons/faSun';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons/faSyncAlt';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag';
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags';
import { faThLarge } from '@fortawesome/free-solid-svg-icons/faThLarge';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTools } from '@fortawesome/free-solid-svg-icons/faTools';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload';
import { faUserCog } from '@fortawesome/free-solid-svg-icons/faUserCog';

export default [
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faArrowDown,
    faArrowLeft,
    faArrowUp,
    faAws,
    faBan,
    faBars,
    faBook,
    faBullhorn,
    faCalendar,
    faChartBar,
    faChartLine,
    faCheck,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircleHalfStroke,
    faClock,
    faCloud,
    faCloudflare,
    faCloudUpload,
    faCloudUploadAlt,
    faCode,
    faCodeBranch,
    faCog,
    faCogs,
    faComments,
    faCompressAlt,
    faCopy,
    faDatabase,
    faDiscord,
    faDownload,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLinkAlt,
    faEye,
    faFile,
    faFileAlt,
    faFileExport,
    faFileSignature,
    faFilter,
    faFolder,
    faFolderOpen,
    faFolderTree,
    faGlobe,
    faHashtag,
    faHistory,
    faHome,
    faICursor,
    faImage,
    faImages,
    faInbox,
    faInfoCircle,
    faLink,
    faList,
    faMinus,
    faMinusSquare,
    faMoon,
    faMusic,
    faPager,
    faPaperPlane,
    faPaste,
    faPlus,
    faQuestionCircle,
    faQuoteRight,
    faRedo,
    faRobot,
    faSave,
    faSearch,
    faServer,
    faShareAlt,
    faShield,
    faShieldAlt,
    faSignOutAlt,
    faSortAlphaUp,
    faSortAmountDown,
    faSpinner,
    faSquare,
    faSun,
    faSync,
    faSyncAlt,
    faTachometerAlt,
    faTag,
    faTags,
    faThLarge,
    faTimes,
    faTools,
    faTrashAlt,
    faUpload,
    faUserCog
];
